<template>
  <v-btn
    :color="color"
    v-on="$listeners"
    v-bind="$attrs"
    exact
    text
  >
    <slot>
      {{ $t('Cancel') }}
    </slot>
  </v-btn>
</template>

<style scoped>

</style>

<script>
  export default {
    name: 'CancelButton',
    inheritAttrs: false,
    props: {
      color: {
        type: String,
        default() {
          return 'secondary';
        },
      },
    },
    data() {
      return {};
    },
  };
</script>

